import React from 'react';
import { Eye, ArrowRight } from 'phosphor-react';
import { useSharedProfile } from '../context/SharedProfileContext';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * SharedProfileBanner - Minimal version for public profiles
 * Shows a discrete indicator instead of a large banner
 * The banner is NO LONGER rendered - we use inline indicators instead
 */
export default function SharedProfileBanner() {
  const { isSharedProfileView } = useSharedProfile();

  // Don't render the large banner anymore
  // Public profile indicator is now handled inline in PublicProfileWrapper
  if (!isSharedProfileView) return null;
  
  // Return null - we've moved to inline indicators
  return null;
}
